<template>
  <div class="ui inverted segment">
    <div
      :class="{ disabled : isLoading || isWithdrawSuccess }"
      class="ui inverted header">
      {{ localization.consentManagement.withdrawConfirmationHeader }}
    </div>
    <div v-html="localization.consentManagement.withdrawConfirmationBody"/>
    <br>
    <div
      :class="{ disabled : isLoading || isWithdrawSuccess }"
      class="ui left floated tertiary circular button"
      @click="updateConfirmation(false)"><i class="chevron left icon"/> {{ localization.global.back }}</div>

    <div
      :class="{ disabled : isLoading || isWithdrawSuccess }"
      class="ui right floated tertiary circular button"
      @click="attemptWithdrawConsent">
      <span v-if="isLoading"><i class="ui spinner loading icon"/></span>
      <span v-if="!isLoading">{{ localization.consentManagement.withdrawConsent }}</span>
    </div>
    <br>
    <br>
    <transition name="fade">
      <div
        v-if="isWithdrawSuccess"
        class="ui info message">{{ localization.consentManagement.successWithdrawMessage }}</div>
    </transition>

  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: '',
  data () {
    return {
      isWithdrawSuccess: false,
      isLoading: false
    }
  },
  methods: {
    ...mapActions(['unmatchUser', 'updateBrazeConsent']),
    updateConfirmation (val) {
      this.$emit('updateConfirmation', val)
    },
    attemptWithdrawConsent (val) {
      this.isLoading = true
      this.unmatchUser().then(() => {
        this.isWithdrawSuccess = true
        this.isLoading = false
        this.updateBrazeConsent(false).then(() => {
        }).catch((error) => {
          Rollbar.error('Error updating Braze consent for ' + this.userId, error)
        })
      }, (error) => {
        Rollbar.error(error)
        this.$router.push({ name: 'ErrorMessage' })
      })

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/study/WithdrawConfirmation.vue